import { defineMessages } from 'react-intl';

export default defineMessages({
    penaltyFreeIncluded: {
        // ref: Web.Job.SideBySide.CoveragePattern.PersonalAutoLine.CovPenaltyFree_Ext=Penalty Free Included
        id: 'custom.policycommon.directives.coverages.Penalty Free Included',
        defaultMessage: 'Penalty Free Included',
    },
});
